/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFreightMatchingDataOutput.ts     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/freight-matching-data-output";

export class AutogenModelFreightMatchingDataOutput<RowType extends ModelRow> extends Endpoint<RowType, RowFreightMatchingDataOutputFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFreightMatchingDataOutput extends ModelRow<RowFreightMatchingDataOutputFields> {
	constructor(values?: Partial<RowFreightMatchingDataOutputFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFreightMatchingDataOutputFields {
	company_id: string;
	data_type: string;
	field_name: string;
	is_active: string;
	is_historical: string;
	listener_enabled: string;
	monitor: string;
	table_name: string;
}

